export enum TSideWidgetView {
	"LIVE_MATCH_TRACKER",
	"LIVE_STREAM",
	"EVENT_LIST",
}
